import BannerZero from "./banner-0.jpg";
import BannerOne from "./banner-1.jpg";
import BannerTwo from "./banner-2.jpg";


function BannerIncidator(props) {
    return (
      <button
        type="button"
        data-bs-target="#bannerIndicators"
        data-bs-slide-to={props.index}
        className={props.active ? "active" : ""}
        aria-current={props.active}
      />
    );
  }

  function BannerImage(props) {
    return (
      <div
        className={"carousel-item " + (props.active ? "active" : "")}
        data-bs-interval="5000"
      >
        <div
          className="ratio"
          style={{ "--bs-aspect-ratio": "50%", maxHeight: "460px" }}
        >
          <img
            className="d-block w-100 h-100 bg-dark cover"
            alt=""
            src={props.image}
          />
        </div>
        <div className="carousel-caption d-none d-lg-block">
        <h5>Welcome to Eco Shop</h5>
        <p>Eco shop is developed and published by the team Leo Alumni of University of Colombo with a vision of enhancing the marketplace of Sri Lankan eco friendly products all over the world.</p>
        </div>
      </div>
    );
  }
  
  function Banner() {
    return (
      <div
        id="bannerIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ marginTop: "56px" }}
      >
        <div className="carousel-indicators">
          <BannerIncidator index="0" active={true} />
          <BannerIncidator index="1" />
          <BannerIncidator index="2" />
        </div>
        <div className="carousel-inner" overflow="hidden">
          <BannerImage image={BannerZero} active={true} />
          <BannerImage image={BannerOne} />
          <BannerImage image={BannerTwo} />
        </div>
      </div>
    );
  }
  
  export default Banner;
  

